import { render, staticRenderFns } from "./salesDetails.vue?vue&type=template&id=7348af89&"
import script from "./salesDetails.vue?vue&type=script&lang=js&"
export * from "./salesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports